// Formato real de filtro do Banco de Questões (mesmo usado pelo tema default —
// src/pages/Admin/Questions/QuestionsFilters.jsx e src/services/questions.js).
export const INITIAL_FILTERS = {
  ineditas: undefined,
  etapa: [],
  usadas_em: [],
  'taxonomies.id': [],
  descritor_ids: []
};

// Atalhos v1 — mesmos valores de filtro do Banco de Questões default
// (src/pages/Admin/Questions/presets.js), pra bater com a API real.
export const PRESETS = [
  {
    id: 'ineditas-bncc',
    label: 'Inéditas BNCC',
    filters: { ineditas: 'true', etapa: ['ano_2_ef', 'ano_5_ef', 'ano_9_ef'] }
  },
  {
    id: 'sem-uso',
    label: 'Sem uso',
    filters: { ineditas: 'true' }
  },
  {
    id: 'reaproveitaveis-de-provas',
    label: 'Reaproveitáveis de provas',
    filters: { usadas_em: ['exam'] }
  }
];
